export default "__VITE_ASSET__Bvv9MsVC__"